<template>
  <ul class="userMenu menuWithSubMenu">
    <li>
      <button class="userToggler button borderless" @click="toggle()">
        <IconUser class="iconUser" stroke="1.25" size="20" color="white" /><span class="userName">{{ username }}</span>
      </button>
      <ul v-bind:class="{ toggled: toggled }" class="subMenu">
        <li @click="toggleBoth()">
          <router-link :to="{ name: 'usersEdit', params: { id: id } }">Editar Perfil</router-link>
        </li>
        <li><router-link :to="{ name: 'logout' }">Sair</router-link></li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { IconUser } from '@tabler/icons-vue'

export default {
  name: 'SettingsComponent',
  data() {
    return {
      toggled: false,
    }
  },
  components: { IconUser },
  computed: {
    ...mapState({
      activeItem: (state) => state.menuItem.active,
    }),
    username() {
      return this.$store.state.auth.jwt?.CustomUserInfo?.Name
    },
    id() {
      return this.$store.state.auth.jwt?.CustomUserInfo?.ID
    },
  },
  methods: {
    toggleMobileMenu() {
      this.$parent.showMobileMenu = !this.$parent.showMobileMenu
    },
    toggleBoth() {
      this.toggleMobileMenu()
      this.toggle()
    },
    toggle() {
      this.toggled = !this.toggled
      if (this.toggled) {
        this.$store.dispatch('menuItem/setActive', 'user')
      }
    },
  },
  watch: {
    activeItem(v) {
      if (v !== 'user') {
        this.toggled = false
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
@use '@/scss/_variables.scss';
@use '@/scss/_navigation.scss';

.userMenu {
  z-index: 1;
  li {
    padding: 0;
  }
}

@media only screen and (min-width: 1000px) {
  .userToggler {
    margin-right: var(--sp);
    margin-top: 0;
    margin-bottom: 0;
    display: flex;
    padding-top: 0;
  }
}
.iconUser {
  margin-right: calc(var(--sp) * 0.5);
}
@media only screen and (max-width: calc(1000px - 1px)) {
  .userName {
    display: none;
  }
  .subMenu {
    position: fixed !important;
    top: 35px !important;
    right: 0 !important;
    left: auto !important;
    background: var(--slightly-darker-primary) !important;
    box-shadow: 3px 3px 0 var(--dark-primary) !important;
    padding: var(--sp) !important;
    li {
      line-height: 1.4;
      padding-bottom: calc(var(--sp) / 2) !important;
    }
  }
}
</style>
